<accordion-title>
    <button onclick="{
                toggleAccordion
            }" class="w-full flex justify-between items-center py-5">
        <slot />
        <span class="text-cyan-800 transition-transform duration-300">
            <svg if={ state.closed } xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
                <path fill-rule="evenodd" d="M11.78 9.78a.75.75 0 0 1-1.06 0L8 7.06 5.28 9.78a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06Z" clip-rule="evenodd" />
            </svg>
            <svg if={ !state.closed } xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
                <path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
            </svg>
        </span>
    </button>

    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS } from '/src/utils/constants'

        export default {
            onBeforeMount(props, state) {
                this.state = {
                    closed: false
                }
            },
            
            toggleAccordion() {
                const new_state = !this.state.closed;
                this.update({
                    closed: new_state
                })
                eventBus.trigger(EVENTS.UI.TOGGLE_ACCORDION, {
                    ckey: this.props.ckey,
                    closed: new_state
                })
            }
        }
    </script>
</accordion-title>
